<template>
    <div>
        <q-modal v-model="show_course_info" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @hide="hideCourseInfo">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideCourseInfo" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ presential.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="row">
                    <div class="col-12 q-pa-md">
                        <div class="col-12 q-my-sm">
                            <p class="q-my-xs text-weight-bold">{{ presential.title }}</p>
                            <p class="q-my-xs">{{ presential.description }}</p>
                            <p class="q-my-xs">{{ `${$t('timezone')}: ${getHumanTimezone(presential.timezone)}` }}</p>
                        </div>

                        <div class="col-12 q-my-sm">
                            <p class="q-my-xs text-weight-bold">{{ $t('instructors') }}</p>
                            <div v-for="(instructor, index) in presential.instructors_list" :key="index">
                                <p class="q-my-xs">{{ instructor.name }} - {{ instructor.email }}</p>
                            </div>
                        </div>

                        <div class="col-12 q-my-sm">
                            <p class="q-my-xs text-weight-bold">{{ $t('address') }}</p>
                            <div>
                                <span class="text-body2">{{ presential.address.address }}, {{ presential.address.number }} - {{ presential.address.neighborhood }}</span>
                            </div>
                            <div>
                                <span class="text-body2">{{ presential.address.city }} - {{ presential.address.state }}/{{ presential.address.state_initials }}</span>
                            </div>
                        </div>

                        <q-card class="bg-grey-1 q-pa-xs q-my-lg" v-if="presential && presential.event_dates.length">
                            <q-card-main class="relative-position">
                                <q-table
                                    :title="$t('training_events')"
                                    :data="presential.event_dates"
                                    :columns="columns"
                                    row-key="id"
                                    dense
                                    :no-data-label="$t('no_data_avaliable')"
                                    :no-results-label="$t('no_results_found')"
                                    class="shadow-0"
                                    >

                                    <q-tr slot="header" slot-scope="props" :props="props">
                                        <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                        {{ $t(col.label) }}
                                        </q-th>
                                    </q-tr>

                                    <template slot="body" slot-scope="props">
                                        <q-tr :props="props">
                                            <q-td key="event_date_type" :props="props">
                                                {{ getEventType(props.row.event_date_type) }}
                                            </q-td>

                                            <q-td key="method" :props="props">
                                                {{ getEventMethod(props.row.event_date_type) }}
                                            </q-td>

                                            <q-td key="hr_start" :props="props">
                                                {{ fDateTime(props.row.hr_start) }}H
                                            </q-td>

                                            <q-td key="hr_end" :props="props">
                                                {{ fDateTime(props.row.hr_end) }}H
                                            </q-td>
                                        </q-tr>
                                    </template>
                                </q-table>
                            </q-card-main>
                        </q-card>

                        <q-card-separator />

                        <div class="text-center q-mt-sm" v-if="!presential.user_subscribed">
                            <span class="text-body2 ">{{ $t('subscription_warning') }}</span>
                        </div>

                        <div class="text-center q-mt-sm" v-if="presential.user_subscribed">
                            <span class="text-body2 text-weight-bold">{{ $t('you_are_subscribed_warning') }}</span>
                        </div>
                    </div>
                </div>

                <q-toolbar slot="footer">
                    <q-card-actions>
                        <q-btn :label="$t('close')" color="tertiary" @click="hideCourseInfo"/>
                        <q-btn
                            :color="presential.user_subscribed ? 'negative' : 'positive'"
                            :label="presential.user_subscribed ? $t('unsubscribe') : $t('subscribe')" @click="confirm_subscribe_presential = true" />
                    </q-card-actions>
                </q-toolbar>
            </q-modal-layout>
        </q-modal>

        <q-dialog prevent-close v-model="confirm_subscribe_presential">
            <span slot="title">{{ presential.user_subscribed ? $t('unsubscribe') : $t('subscribe') }}</span>

            <span slot="message">
                {{
                    presential.user_subscribed
                    ? $t('unsubscribe_confirmation')
                    : $t('subscribe_confirmation')
                 }}
            </span>

            <span slot="body" v-if="!presential.user_subscribed">
                <q-field>
                    <q-checkbox v-model="check_emails_presential" :label="$t('receive_emails_about_this_training')" />
                </q-field>
            </span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="tertiary" :label="$t('close')" @click="hideCourseInfo()"/>
                <q-btn
                    :color="presential.user_subscribed ? 'negative' : 'positive'"
                    :label="presential.user_subscribed ? $t('unsubscribe') : $t('subscribe')" @click="toggleSubscription" />
            </template>
        </q-dialog>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { formatDate, getDateDiff } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    props: ['presential', 'show'],

    data() {
        return {
            confirm_subscribe_presential: false,
            check_emails_presential: true,
            columns: [
                {
                    name: 'event_date_type',
                    required: true,
                    label: 'event_type',
                    align: 'left',
                    field: 'event_date_type',
                    sortable: false,
                },
                {
                    name: 'method',
                    required: true,
                    label: 'method',
                    align: 'left',
                    field: 'event_date_type',
                    sortable: false,
                },
                {
                    name: 'hr_start',
                    required: true,
                    label: 'hr_start',
                    align: 'left',
                    field: 'hr_start',
                    sortable: false,
                },
                {
                    name: 'hr_end',
                    required: true,
                    label: 'hr_end',
                    align: 'left',
                    field: 'hr_end',
                    sortable: false,
                }
            ],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_course_info: {
            get() {
                return this.show
            },
            set() {
                this.$emit('hideCourseInfo')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '50vw'
        },
    },

    methods: {
        toggleSubscription() {
            this.$q.loading.show()

            let data = {
                    'receive_notifications': this.check_emails_presential,
                    'subscribe': this.presential.user_subscribed ? false : true
                }

            this.$axios.post(`/etraining_presential/presential/${this.presential.id}/save_subscription/`, data, this.getHeader)
            .then(response => {

                if (!this.presential.user_subscribed) {
                    this.presential.user_subscribed = true

                    this.$q.notify({
                        message: this.$t('subscribed_for_presential_training_successfully'),
                        type: 'positive',
                        icon: 'fas fa-sign-in-alt'
                    })
                }
                else {
                    this.presential.user_subscribed = false

                    this.$q.notify({
                        message: this.$t('unsubscribed_for_presential_training_successfully'),
                        type: 'positive',
                        icon: 'fas fa-sign-out-alt'
                    })
                }
            })
            .catch((e) => {
                if (e.response.data.orientation === 'no_vacancy') {
                    this.$q.notify({
                        message: this.$t('no_vacancy'),
                        type: 'negative',
                        icon: 'fas fa-users-slash'
                    })
                    return
                } else console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
                this.hideCourseInfo()
            })
        },

        getSubscribeConfirmText() {
            if (this.presential.user_subscribed) return 'confirm_subscription'
            else return 'cancel_subscription'
        },

        hideCourseInfo() {
            this.confirm_subscribe_presential = false
            this.$emit('hideCourseInfo')
        },

        getEventType(ev) {
            if (ev === 1) return this.$t('presential')
            if (ev === 2) return this.$t('webcast')
            else return this.$t('live_class')
        },

        getEventMethod(ev) {
            if (ev === 1) return this.$t('presential')
            else return this.$t('online')
        },

        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY - HH:mm'
                    break
                    default: format = 'MM-DD-YYYY - HH:mm'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getHumanTimezone(location) {
            const gmt = moment.tz(location).format('z')
            if (gmt === 'GMT') {
                return `${gmt} 0`
            } else return `GMT ${gmt}`
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
